import RewardTriggerEnum from '../../../../../Spirit/Entities/Enums/RewardTriggerEnum';
import FilterRequest from '../../../../../Spirit/Common/Extensions/Models/FilterRequest';

export default class SearchRewardRequest extends FilterRequest {
	Name?: string = '';
	Trigger?: RewardTriggerEnum = null;
	constructor(obj?: Partial<SearchRewardRequest>) {
		super(obj);
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
